/* post-t7-1, Bloque F1 (#580): "START FREE" CREA EL INVITADO EN LA PAGINA, NO EN EL SERVIDOR.

   ARCHIVO EN ASCII A PROPOSITO (regla de la casa para los `.js` nuevos).

   `GET /api/start` (el enlace de las paginas publicas) ya no crea nada: manda a `/dashboard?start=1` con las cinco
   `utm_*` del clic. La pagina, ya en un navegador de verdad, ve `start=1` sin sesion y crea el invitado por la puerta
   de siempre (`POST /auth/guest`). Para el mismo clic, la atribucion que guarda es LA MISMA que guardaba el servidor:
   las cinco etiquetas (recortadas a 500), `referrer` = la pagina donde se dio el clic (el `Referer` de antes es el
   `document.referrer` de ahora: una redireccion no lo cambia) y `landing_path` = el camino de esa pagina, sacado como
   lo sacaba `urllib.parse.urlparse` (no "/dashboard"), y `captured_at` con la forma de `datetime.isoformat()`.

   En la app, `start=1` no hace nada. */

export const LLAVES_UTM = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'];
const LARGO = 500;

/** `ruta` es camino mas consulta ("/dashboard?start=1&..."). */
export function esArranqueDeInvitado(ruta) {
  if (typeof ruta !== 'string') return false;
  const corte = ruta.indexOf('?');
  if (corte === -1 || ruta.slice(0, corte) !== '/dashboard') return false;
  try {
    return new URLSearchParams(ruta.slice(corte)).get('start') === '1';
  } catch {
    return false;
  }
}

/** El camino de una URL como `urlparse(url).path` (sin parametros `;...` del ultimo tramo); null si no hay. */
export function caminoComoElServidor(url) {
  if (typeof url !== 'string' || !url) return null;
  let resto = url.split('#')[0].split('?')[0];
  const conEsquema = /^[A-Za-z][A-Za-z0-9+.-]*:/.exec(resto);
  if (conEsquema) resto = resto.slice(conEsquema[0].length);
  if (resto.startsWith('//')) {
    const fin = resto.slice(2).search(/[/]/);
    const anfitrion = fin === -1 ? resto.slice(2) : resto.slice(2, 2 + fin);
    // urlparse lanza con un corchete de IPv6 sin pareja; el servidor entonces no guardaba camino
    if (anfitrion.includes('[') !== anfitrion.includes(']')) return null;
    resto = fin === -1 ? '' : resto.slice(2 + fin);
  }
  const barra = resto.lastIndexOf('/');
  const pc = resto.indexOf(';', barra === -1 ? 0 : barra);
  if (pc !== -1) resto = resto.slice(0, pc);
  return resto || null;
}

/** Un instante con la forma de `datetime.now(timezone.utc).isoformat()`. */
export function isoComoElServidor(fecha) {
  const iso = fecha.toISOString();
  const ms = fecha.getUTCMilliseconds();
  return `${iso.slice(0, 19)}${ms ? `.${String(ms).padStart(3, '0')}000` : ''}+00:00`;
}

/** La atribucion del clic, campo por campo como la armaba `GET /api/start`. */
export function atribucionDelClic(search, referrer, ahora = new Date()) {
  const params = new URLSearchParams(search || '');
  const out = {};
  LLAVES_UTM.forEach((k) => {
    const v = params.get(k);
    if (v) out[k] = v.slice(0, LARGO);
  });
  if (referrer) {
    out.referrer = referrer.slice(0, LARGO);
    const camino = caminoComoElServidor(referrer);
    if (camino) out.landing_path = camino.slice(0, LARGO);
  }
  out.captured_at = isoComoElServidor(ahora);
  return out;
}

let enVuelo = null;

/** Crea UN invitado aunque el efecto corra dos veces: la segunda llamada recibe la misma promesa. */
export function arrancarInvitado(loginAsGuest, atribucion) {
  if (!enVuelo) {
    enVuelo = Promise.resolve()
      .then(() => loginAsGuest({ atribucion }))
      .finally(() => { enVuelo = null; });
  }
  return enVuelo;
}
